import type {ComponentProps} from 'react';
import type {ResponsiveHeader} from '../..';
import styles from './view-style.module.css';

type Props = Pick<
  ComponentProps<typeof ResponsiveHeader>,
  'viewStyle' | 'setViewStyle'
>;

export function ViewStyle({viewStyle, setViewStyle}: Props) {
  const changeStyleToList = () => {
    setViewStyle('list');
  };

  const changeStyleToTitle = () => {
    setViewStyle('title-only');
  };

  return (
    <div className={styles.viewStyle}>
      <p className={styles.paragraph}>ビュースタイル</p>
      <div className={styles.container}>
        <button
          className={
            viewStyle === 'list' ? styles.selectedButton : styles.button
          }
          type='button'
          data-view-style={viewStyle}
          onClick={changeStyleToList}
        >
          リスト
        </button>
        <button
          className={
            viewStyle === 'list' ? styles.button : styles.selectedButton
          }
          type='button'
          onClick={changeStyleToTitle}
        >
          タイトルのみ
        </button>
      </div>
    </div>
  );
}
